var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"close-icon",class:{
      'close-icon-non-fullscreen': !_vm.isFullScreen && !_vm.isCarousel,
      'close-icon-horizontal-swipe-mobile':
        _vm.isHorizontalSwipeOnMobile && _vm.isMobile,
    },on:{"click":function($event){$event.stopPropagation();return _vm.handleClosePlayer.apply(null, arguments)}}},[_c('CloseIcon')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }